import React from 'react';
import type {
  TaskAssignmentResponse,
  TaskDefinitionResponse,
} from 'src/api/ProactApiClient';
import {FormViewComponentV2} from 'src/app/forms/FormViewComponent/FormViewComponentV2';
import {toFormDataV2} from 'src/app/forms/engine/formData';
import {toTaskDefinitionFormData} from 'src/app/tasks/taskFeatureTypes';
import {taskFieldDefinitions} from 'src/app/tasks/taskHelpers';
import {ErrorAlert} from 'src/design/molecules/ErrorAlert';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {useGetFormDefinitionSelectOptionsQuery} from 'src/redux/queries/formDefinition';
import useSkipTokensByFeature from 'src/shared/hooks/useSkipTokensByFeature';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {useAssignedFormMeta} from './AssignedForm';

export const AssignedFormDefinitionView: React.FC<{
  item: TaskDefinitionResponse;
}> = ({item}) => {
  const {formMeta, isLoading, error} = useAssignedFormMeta(item.state);
  if (isLoading) return <TableBodyRender isLoading />;
  if (error) return <ErrorAlert message={parseErrorMessage(error)} />;
  return (
    <FormViewComponentV2
      formData={toTaskDefinitionFormData(item)}
      formMeta={formMeta.filter(field => field.name !== 'subject')}
    />
  );
};

export const AssignedFormAssignmentView: React.FC<{
  item: TaskAssignmentResponse;
}> = ({item}) => {
  const {skipForms} = useSkipTokensByFeature();
  const {data, isLoading, isFetching, error} =
    useGetFormDefinitionSelectOptionsQuery(
      {start: 0, length: 10000, active: true, includeSubforms: true},
      {skip: skipForms}
    );
  if (isLoading || isFetching) return <TableBodyRender isLoading />;
  if (error) return <ErrorAlert mt={0} message={parseErrorMessage(error)} />;
  const formMeta = [
    taskFieldDefinitions.formDefinitionId(data?.data ?? []),
    taskFieldDefinitions.dueInDays,
  ];
  return (
    <FormViewComponentV2
      formData={toFormDataV2(item.taskDefinition)}
      formMeta={formMeta}
    />
  );
};
